import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Event } from '@shared/models/event.model';
import { Observable, of } from 'rxjs';
import { Response } from '@shared/models/response.model';
import { catchError } from 'rxjs/operators';
import { RoutesPath } from '@shared/routes-path';
import { Error } from '@shared/interfaces/error.interface';
import { BaseComponent } from '@shared/components/base.component';
import { EventsServicePublic } from '@layouts/default/layouts/guest/pages/events/events.service';

@Injectable({
  providedIn: 'root',
})
export class DetailEventResolve extends BaseComponent implements Resolve<Response<Event>> {
  constructor(public eventsService: EventsServicePublic) {
    super();
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Response<Event>> {
    // '+' convert string to number
    const id = +route.paramMap.get('id');
    if (isNaN(id)) {
      this.toast.error(this.translate.instant('EVENT.not_corrected_id'));
      const error = { message: 'not_found' };
      return this.errorHandle(error);
    }
    return this.eventsService.getEvent(id).pipe(
      catchError((error) => {
        this.toast.error(
          this.translate.instant('EVENT.not_found'),
          this.translate.instant('EVENT.event_error')
        );
        return this.errorHandle(error);
      })
    );
  }

  errorHandle(error: Error) {
    this.router.navigate([RoutesPath.default.events]);
    return of({ data: null, error: error.message });
  }
}
